module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Extended-Medium.6a78dd8d.otf";